import { render, staticRenderFns } from "./StageBorder.vue?vue&type=template&id=6d2c2cc2&scoped=true&"
import script from "./StageBorder.vue?vue&type=script&lang=js&"
export * from "./StageBorder.vue?vue&type=script&lang=js&"
import style0 from "./StageBorder.vue?vue&type=style&index=0&id=6d2c2cc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c2cc2",
  null
  
)

export default component.exports